import { useRef } from 'react';
import PropTypes from 'prop-types';
import { hidePlayer, showLoading } from '../utils';
import useComputePosition from './useComputePosition';

const useHover = ({
  hoveredItemParent,
  getContainer,
  containerOffsetX,
  containerOffsetY,
  containerPlacement,
  stopAudioFeatures,
  loadingIndicatorRef,
  cbPlayerRef,
  uuid,
  onMouseLeaveCallback,
}) => {
  const currentPositionProps = useRef();
  const { doComputePosition } = useComputePosition();

  const tryComputingPosition = (target, container = '') => {
    const {
      ypos,
      offsetx: currentItemOffsetX,
      offsety: currentItemOffsetY,
    } = target.dataset;

    const PLACEMENT_MAP = {
      top: 'top',
      bottom: 'bottom',
    };

    const placement =
      PLACEMENT_MAP[ypos] || PLACEMENT_MAP[containerPlacement] || 'auto';

    const offsetX = currentItemOffsetX || containerOffsetX;
    const offsetY = currentItemOffsetY || containerOffsetY;

    currentPositionProps.current = {
      currentTarget: target,
      container,
      placement,
      offsetX,
      offsetY,
      hoveredElem: target,
    };

    doComputePosition({
      ...currentPositionProps.current,
    });
  };

  const onBlur = (e) => {
    const { target, relatedTarget } = e;
    setTimeout(() => {
      onDoMouseLeave(target, relatedTarget);
    }, 0);
  };

  const onMouseLeave = (e) => {
    onMouseLeaveCallback();
    const { target, relatedTarget } = e;
    setTimeout(() => {
      onDoMouseLeave(target, relatedTarget);
    }, 0);
  };

  const onDoMouseLeave = (target, relatedTarget) => {
    const { reference } = target.closest(hoveredItemParent).dataset;
    const container = getContainer();
    if (
      reference &&
      relatedTarget !== container &&
      !container?.contains(relatedTarget)
    ) {
      const customReference = `${reference}---${uuid.getNameSpace()}`;
      const currentItemEl = container?.querySelector(
        `div[data-reference="${customReference}"]`,
      );
      if (currentItemEl) {
        currentItemEl.style = null;
        currentItemEl?.classList?.remove('is-visible');
        currentItemEl?.classList?.add('is-invisible');
      }

      stopAudioFeatures(customReference);

      //if other question was hovered, stop hiding the loading and the player container
      if (!container?.querySelector('.is-visible')) {
        showLoading(
          container,
          loadingIndicatorRef.current,
          cbPlayerRef.current,
        );
        hidePlayer(container);
      }
    }
  };

  const triggerMouseLeave = (e) => {
    const { target } = e;
    const hoverParentElement = target.closest(hoveredItemParent);

    if (hoverParentElement) {
      hoverParentElement?.dispatchEvent(new Event('mouseleave'));
    }
  };

  return [
    {
      tryComputingPosition,
      onBlur,
      onMouseLeave,
      triggerMouseLeave,
    },
  ];
};

useHover.propTypes = {
  containerPlacement: PropTypes.string.isRequired,
  stopAudioFeatures: PropTypes.func.isRequired,
};

export default useHover;
